import { ComponentChildren, VNode } from "preact";
import { useErrorBoundary } from "preact/hooks";
import Button from "../Button";
import Container from "../Container";

interface ErrorBoundaryProps {
  children?: ComponentChildren;
}

const ErrorBoundary = ({ children }: ErrorBoundaryProps): VNode<any> | null => {
  const [error, resetError] = useErrorBoundary();

  if (error) {
    return (
      <div className="lc-bg-cfa-blue-950 lc-flex lc-justify-center lc-w-full lc-pt-11">
        <Container>
          <h1 className="lc-text-white">Oh no! Something went wrong</h1>
          <p className="lc-text-white">
            Here's the error message: {error.message}
          </p>

          <Button onClick={resetError} text="Try again"></Button>
        </Container>
      </div>
    );
  }

  return children as VNode<any> | null;
};

export default ErrorBoundary;
